import { Name } from '../../public/my.env';

export let wsConnection = null;

const serverConfig = {
  st6: { httpsPort: 3107, httpPort: 3007, baseUrl: 'trainerapi-s1.liverunapp.com' },
  st5: { httpsPort: 3105, httpPort: 3005, baseUrl: 'trainerapi-s.liverunapp.com' },
  st4: { httpsPort: 3104, httpPort: 3004, baseUrl: 'trainerapi.liverunapp.com' },
};

const getWebSocketUrl = () => {
  const config = serverConfig[Name];
  if (!config) return 'ws://localhost:4000/'; // Default URL for local testing

  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  const port = window.location.protocol === 'https:' ? config.httpsPort : config.httpPort;
  return `${protocol}://${config.baseUrl}:${port}/`;
};

export async function createConnection() {
  console.log('Starting connection to WebSocket Server', wsConnection);

  if (!wsConnection || wsConnection.readyState === WebSocket.CLOSED) {
    const webSocketUrl = getWebSocketUrl();
    wsConnection = new WebSocket(webSocketUrl);

    wsConnection.onopen = () => {
      console.log('WebSocket connection established.');
    };

    wsConnection.onclose = (evt) => {
      console.log('WebSocket closed:', evt);
      wsConnection = null;
    };

    wsConnection.onerror = (evt) => {
      console.error('WebSocket error:', evt);
    };
  }
}

export const openSocket = () => {
  return wsConnection ? wsConnection.readyState : WebSocket.CLOSED;
};

export const sendRequest = async (obj) => {
  if (openSocket() !== WebSocket.OPEN) {
    await createConnection();
    setTimeout(() => {
      if (wsConnection.readyState === WebSocket.OPEN) {
        wsConnection.send(obj);
      } else {
        console.log('WebSocket is not open. Cannot send message.');
      }
    }, 1000); // Consider implementing a more robust retry mechanism instead
  } else {
    wsConnection.send(obj);
  }
};

export const sendRunnerDataMsg = (data) => {
  return sendRequest(JSON.stringify(data));
};



// WEBPACK FOOTER //
// ./src/services/webSocket.js